import React from 'react';
import { observer } from 'mobx-react';
import { useStore } from '../../stores/Store';
import ripple from '../../assets/images/Ripple@4x-1.svg'
import './style.css';

const LoadingScreen = observer(() => {
  const store = useStore();
  let { isLoading } = store;

  if (!isLoading) {
    return null;
  } else {
    return (
      <div className='LoadingScreen'>
        <div className='Loading'>
          <div className="loader">
            <img src={ripple} style={{height:'30%', position:'fixed'}} />
          </div>
        </div>
      </div>
    );
  }
});

export default LoadingScreen;
